"use client";

import { medimoQC } from "@medimo/core-api/internal/next";

// キルスイッチ自体の再チェック間隔。お知らせ本体のポーリングと同じ60秒にすると、
// /v4/feature-flags へのリクエストがお知らせ本体の分とほぼ同数発生し、APIへの
// リクエスト数が単純に2倍になってしまう(SREレビュー指摘)。キルスイッチは負荷対策
// 用途であり反応が数分遅れても問題ないため、長めの間隔にしてリクエスト数の増加を
// 抑える
const KILL_SWITCH_CHECK_INTERVAL_MS = 5 * 60 * 1000;

// お知らせバナーのポーリングを、AWS AppConfig のフィーチャーフラグ(notification_banner_polling)で
// 即座に止められるようにするキルスイッチ。is_show_in_banner をOFFにしても対象画面を開いている
// 利用者のポーリング自体は止まらず、コードをrevertしても既に開いているタブは古いJSのまま
// ポーリングを続けるため、実行中のポーリングループ自体を止める手段が別途必要
// (DD-2026-0920 セクション10参照)。フラグ自体もこの間隔で再チェックすることで、
// 既に開いているタブにも反映されるようにする
export const useIsNotificationBannerPollingEnabled = (): boolean => {
  const { data, status } = medimoQC.useQuery(
    "get",
    "/v4/feature-flags",
    {},
    {
      refetchInterval: KILL_SWITCH_CHECK_INTERVAL_MS,
      retry: false,
    },
  );

  // 取得成功(success)で、AppConfigが明示的にtrueを返した場合のみポーリングを有効にする。
  // フィールド自体が無い(バックエンドのスキーマがまだ対応していない等)場合にtrue扱い
  // してしまわないよう、`!== false`ではなく`=== true`で厳密に判定する。
  // 初回取得中(pending)は値がまだ分からないため推測せずポーリングを開始しない。
  // 取得に失敗した場合(error)もフェイルクローズにする。/v4/feature-flags は
  // /v2/notifications と同じバックエンド(internal.main.app)で動いており、前者が
  // 失敗する状況はバックエンド自体が不調である可能性が高いため、お知らせ取得側で
  // ポーリングを続行しても成功する見込みが薄く、キルスイッチの目的(負荷が問題化した
  // 場合に止める)に反する。バックエンド障害時の案内という本機能の目的は、
  // お知らせ取得自体のretry:falseで別途担保している
  return (
    status === "success" && data?.notification_banner_polling_enabled === true
  );
};
